import { useState } from "react"
import { Form, Button, Container, Col } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { css } from "@emotion/react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { validEmailRegex } from "../../constant/utils"
import Loader from "../../components/Loader"
import { forgotPassword } from "../../data/authenticationSlice"
import { byPrefixAndName } from "@awesome.me/kit-de80aecb6a/icons"

const componentStyle = css`
    .green * {
        color: #41bb4a;
    }
`

const ForgotPassword = () => {
    const dispatch = useDispatch()

    const { fetchStatus } = useSelector((state) => state.authentication)

    const [userEmail, setUserEmail] = useState("")
    const [submitted, setSubmitted] = useState(false)
    const [errors, setErrors] = useState({ email: null, standardError: null })

    const handleChange = (event) => {
        setUserEmail(event.target.value)
    }

    const handleSubmit = (event) => {
        event.preventDefault()

        if (!userEmail || !validEmailRegex.test(userEmail)) {
            setErrors({
                email: !userEmail || !validEmailRegex.test(userEmail) ? "Please enter a valid email" : ""
            })
            return false
        }

        // Set submitted to true to trigger the rendering of the message
        dispatch(forgotPassword({ email: userEmail })).then(({ payload }) => {
            if (payload?.succeeded) {
                setSubmitted(true)
            } else if (!payload?.succeeded && payload?.errorMessage) {
                setErrors((preErrors) => ({
                    ...preErrors,
                    standardError: payload?.errorMessage
                }))
            }
        })
    }

    return (
        <Container
            css={componentStyle}
            className="d-flex justify-content-center align-items-center vh-100">
            <Loader show={fetchStatus === "loading"} />
            <Col
                md={4}
                className="auth-box bg-white">
                {submitted ? (
                    <>
                        <div className="text-center mb-4">
                            <h1 className="text-center mb-4">Reset Password</h1>
                            <FontAwesomeIcon
                                icon={byPrefixAndName.fal["circle-check"]}
                                size="4x"
                                className="green"
                            />
                        </div>
                        <div className="text-center mb-4">
                            If your account exists you will receive an email with instructions to reset your password.
                            <br />
                            <br />
                            Please check you spam folder if you have not received.
                        </div>
                    </>
                ) : (
                    <>
                        <h1 className="text-center mb-2">Reset Password</h1>
                        <div className="text-center mb-4">Enter your email to reset your password</div>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group controlId="formEmail">
                                <Form.Label>
                                    Email<span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    className="form-control-sm"
                                    value={userEmail}
                                    onChange={handleChange}
                                    placeholder="Enter email"
                                />
                                {errors?.email && <Form.Text className="text-danger">{errors?.email}</Form.Text>}
                            </Form.Group>
                            {errors?.standardError && <div style={{ color: "red" }}>{errors?.standardError}</div>}

                            <div className={`d-grid ${errors?.standardError ? "mt-1" : "mt-4"}`}>
                                <Button
                                    className="btn-sm"
                                    type="submit"
                                    variant="primary">
                                    Submit
                                </Button>
                            </div>
                        </Form>
                    </>
                )}
            </Col>
        </Container>
    )
}

export default ForgotPassword
